import { Labeled, TextField, TextFieldProps } from 'react-admin';

export const InlineTextField = ({ label, ...rest }: TextFieldProps) => (
  <Labeled direction="row" label={label ? <span>{label}:&nbsp;</span> : ''} sx={{}} typography="body1">
    <TextField typography="caption" {...rest} />
  </Labeled>
);

export default InlineTextField;
